// @core/api/endpoints/chat/get_message.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  MessageResponse,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Get message by ID
 * Retrieves a single message by its ID, including content, attachments, reactions, and thread information.
 */
export async function GetMessage(
  conversation_id: string,
  message_id: string,
  options?: RequestOptions
): Promise<MessageResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/messages/:message_id`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  requestPath = requestPath.replace(':message_id', encodeURIComponent(message_id));
  const requestOptions = options;
  return client.get<MessageResponse>(requestPath, { ...requestOptions });
}
